<template>
    <section class="product-analysis">
        <title-date-component :titleOption="titleOption" :initDateRange="initDateRange" @changeDate="changeDate" @downloadMenpiaoData="downloadMenpiaoData"></title-date-component>
        <section class="data-box">
            <section class="search-box">
                <input type="text" placeholder="请输入商品名称、编号" v-model="productStr" />
                <input type="button" value="搜索" @click="getData()" />
            </section>
            <table-component :tableInfo="tableInfo" style="margin-top:20px;"></table-component>
            <v-pagination
                :current='currentPage'
                :total='Math.ceil(totalCount / 10)'
                :size="'md'"
                :first="false"
                :last="false"
                v-on:current-change="currentChangeFunc($event)"
            ></v-pagination>
        </section>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .product-analysis {
        background-color: #FFF;
        padding: 10px 20px 10px 20px;
        margin-top: 20px;
        width: 98%;
        margin-left: 1%;
        .data-box {
            width: 100%;
            padding-left: 15px;
            margin-top: 35px;
            padding-bottom: 15px;
            .search-box {
                width: 100%;
                height: 35px;
                input[type="text"] {
                    width: 240px;
                    height: 100%;
                    display: inline-block;
                    vertical-align: top;
                }
                input[type="button"] {
                    width: 80px;
                    height: 100%;
                    background-color: #2CA4F7;
                    color: #FFF;
                    border: 0;
                    border-radius: 2px;
                }
            }
            > div {
                text-align: right;
                .pagination {
                    margin: 20px 0 0 0;
                    li {
                        &.active span {
                            background-color: #2CA4F7;
                            border-color: #2CA4F7;
                        }
                        a {
                            color: #2CA4F7;
                        }
                    }
                }
            }
        }
    }
</style>

<script>
    import TitleDateComponent from '../../../../components/title-date/TitleDate.vue'
    import TableComponent from '../../../../components/table/Table.vue'
    import menpiaoDataPlatform from 'api/menpiaoDataPlatform'
    import MomentFormat from '../../../../filters/moment-format'
    import percentformat from '../../../../filters/percent-format'

    export default {
        components: {
            TitleDateComponent,
            TableComponent
        },
        data () {
            return {
                titleOption: {  // 单元块名称和日期选择配置
                    title: '商品分析',  // 名称
                    dateRangeSelect: true, // 是否显示日期区间下拉框
                    dateMaxRangeLength: 60, // 日期区间最大跨度
                    download: true, // 是否显示下载按钮
                    showDate: {
                        startDate: MomentFormat.getSevenDate(),
                        endDate: MomentFormat.getYestoday()
                    }
                },
                productStr: '',
                date: {
                    startDate: MomentFormat.getSevenDate(),
                    endDate: MomentFormat.getYestoday()
                },
                initDateRange: MomentFormat.getSevenDate() + ' ~ ' + MomentFormat.getYestoday(),
                currentPage: 1,
                totalCount: 0,
                tableInfo: {
                    title: [
                        {
                            name: '商品编号',
                            value: 'productId',
                            style: 'width:120px; text-align:left;'
                        },
                        {
                            name: '商品名称',
                            value: 'productName',
                            style: 'width:25%; text-align:left;'
                        },
                        {
                            name: '浏览量',
                            value: 'intentionPV'
                        },
                        {
                            name: '访客数',
                            value: 'intentionUV'
                        },
                        {
                            name: '访购率',
                            value: 'visitPurchaseRate'
                        },
                        {
                            name: '销量',
                            value: 'payQuantity'
                        },
                        {
                            name: '销售额',
                            value: 'payAmount'
                        },
                        {
                            name: '验证量',
                            value: 'consumeQuantity'
                        },
                        {
                            name: '退款券量',
                            value: 'refundQuantity'
                        },
                        {
                            name: '用户退款率',
                            value: 'refundRate'
                        },
                        {
                            name: '',
                            value: 'action'
                        }
                    ],
                    data: []
                }
            }
        },
        props: ["salePlatform"],
        watch: {
            salePlatform: {
                handler: function () {
                    this.getData();
                },
                deep: true
            }
        },
        methods: {
            getData () {
                menpiaoDataPlatform.getProductData(this.salePlatform, this.date.startDate, this.date.endDate,
                    this.productStr, false, this.currentPage, 10)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            let data = res.data;
                            let arr = [];
                            data.forEach((item, index) => {
                                let o = {};
                                o.productId = {};
                                o.productId.value = item.productId;
                                o.productName = {};
                                o.productName.value = item.productName;
                                o.productName.style = 'text-align:left;';
                                o.intentionPV = {};
                                o.intentionPV.value = item.sum.intentionPV;
                                o.intentionUV = {};
                                o.intentionUV.value = item.sum.intentionUV;
                                o.visitPurchaseRate = {};
                                o.visitPurchaseRate.value = percentformat(item.sum.visitPurchaseRate, true);
                                o.payQuantity = {};
                                o.payQuantity.value = item.sum.payQuantity;
                                o.payAmount = {};
                                o.payAmount.value = item.sum.payAmount;
                                o.consumeQuantity = {};
                                o.consumeQuantity.value = item.sum.consumeQuantity;
                                o.refundQuantity = {};
                                o.refundQuantity.value = item.sum.refundQuantity;
                                o.refundRate = {};
                                o.refundRate.value = percentformat(item.sum.refundRate, true);
                                o.action = {};
                                o.action.value = '<a href="javascript:void(0);">查看趋势</a>';
                                o.action.showTc = true;
                                o.action.params = {
                                    productId: item.productId,
                                    productName: item.productName,
                                    startDate: this.date.startDate,
                                    endDate: this.date.endDate
                                };
                                arr.push(o);
                            });
                            this.tableInfo.data = arr;
                            this.totalCount = res.totalCount;
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                    })
                    .catch((err) => {
                        this.$notify.error({
                            title: '错误',
                            message: err.message || '请求失败'
                        })
                        console.log(err);
                    })
            },

            // 切换页码
            currentChangeFunc (ev) {
                this.currentPage = ev.current;
                this.getData();
            },

            // 切换日期
            changeDate (params) {
                this.date.startDate = params.dateRange.startDate;
                this.date.endDate = params.dateRange.endDate;
                this.currentPage = 1;
                this.getData();
            },

            // 下载
            downloadMenpiaoData () {
                menpiaoDataPlatform.downloadProductData(this.salePlatform, this.date.startDate, this.date.endDate,
                    this.productStr, false);
            }
        },
        mounted () {
            this.getData();
        }
    }
</script>



// WEBPACK FOOTER //
// ProductAnalysis.vue?4aee0c4f